// extracted by mini-css-extract-plugin
export default {"container":"sl22D","withIllustration":"CQx_N","illustration":"CJbYG","title":"KiaBo","address":"w7lqB","buttonsSection":"Wk_PG","addStepButton":"dMTdR"};